import {Injectable} from '@angular/core';

@Injectable()
export class CommandsGuiGadget {
    constructor() {

    }

    activateGadget() {
    }

    clientHeight() {
    }

    clientWidth() {
    }

    disableGadget() {
    }

    enableGadget() {
    }

    freeGadget() {
    }

    gadgetFont() {
    }

    gadgetGroup() {
    }

    gadgetHeight() {
    }

    gadgetText() {
    }

    gadgetWidth() {
    }

    gadgetX() {
    }

    gadgetY() {
    }

    hideGadget() {
    }

    queryObject() {
    }

    setGadgetFont() {
    }

    setGadgetLayout() {
    }

    setGadgetShape() {
    }

    setGadgetText() {
    }

    showGadget() {
    }
}
